import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "filter-box" }
const _hoisted_12 = { class: "filter-box" }
const _hoisted_13 = { class: "filter-box" }
const _hoisted_14 = { class: "filter-box" }
const _hoisted_15 = { class: "split-table-layout" }
const _hoisted_16 = {
  key: 1,
  class: "color-cancle"
}
const _hoisted_17 = {
  key: 2,
  class: "color-cancle"
}
const _hoisted_18 = { class: "clearfix tab-title btn-container mt-10" }
const _hoisted_19 = { class: "tab-title_left fl" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { style: {"color":"red"} }
const _hoisted_22 = {
  class: "form-title mt-20 mb-15",
  style: {"display":"flex","align-items":"center","justify-content":"space-between"}
}
const _hoisted_23 = { class: "left" }
const _hoisted_24 = { class: "underlineForm" }
const _hoisted_25 = { class: "dialog-footer" }
const _hoisted_26 = { class: "dialog-footer" }
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { class: "dialog-footer mt-20" }
const _hoisted_29 = { key: 4 }
const _hoisted_30 = { class: "dialog-footer mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_CommandRender = _resolveComponent("CommandRender")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableSplitter = _resolveComponent("TableSplitter")!
  const _component_TraceInfo = _resolveComponent("TraceInfo")!
  const _component_BusinessInfo = _resolveComponent("BusinessInfo")!
  const _component_LogisticTable = _resolveComponent("LogisticTable")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "label" }, "客户名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.customerCompanyName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.customerCompanyName) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "label" }, "业务编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessNo,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.businessNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[37] || (_cache[37] = _createElementVNode("span", { class: "label" }, "业务品牌", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessBrand,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.businessBrand) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[38] || (_cache[38] = _createElementVNode("span", { class: "label" }, "业务名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.businessName) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[39] || (_cache[39] = _createElementVNode("span", { class: "label" }, "型号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessModel,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.businessModel) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[40] || (_cache[40] = _createElementVNode("span", { class: "label" }, "业务代表", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.salesManId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.salesManId) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onFocus: _ctx.handleSalesManFocus,
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesManOption, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onFocus", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "label" }, "订单号码", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.customerOrderNo,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.customerOrderNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[42] || (_cache[42] = _createElementVNode("span", { class: "label" }, "发票号码", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.invoiceNo,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.invoiceNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[43] || (_cache[43] = _createElementVNode("span", { class: "label" }, "开票状态", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.status,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listQuery.status) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  onChange: _ctx.handleFilter,
                  clearable: "",
                  size: _ctx.t('table.btnSize')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOption, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[44] || (_cache[44] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[45] || (_cache[45] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[46] || (_cache[46] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[47] || (_cache[47] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))]),
          _cache[48] || (_cache[48] = _createStaticVNode("<span class=\"ml-10 filter-mark\"><span class=\"status-item\"><span class=\"status-square\" style=\"background-color:red;\"></span><span class=\"status-text\">部分开票、待开票</span></span><span class=\"status-item\"><span class=\"status-square\" style=\"background-color:gray;\"></span><span class=\"status-text\">已作废</span></span><span class=\"status-item\"><span class=\"status-square\" style=\"background-color:#F3D03C;\"></span><span class=\"status-text\">待确认作废</span></span><span class=\"status-item\"><i class=\"iconfont icon-tubiao-40\"></i><span class=\"status-text\">有备注信息</span></span><span class=\"status-item\"><i class=\"iconfont icon-tubiao-40 cell-blue\"></i><span class=\"status-text\">开票资料有修改</span></span></span>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          class: "split-pane-top vue-grid-item",
          style: _normalizeStyle({ height: _ctx.isSubMenuCollapse ? '100%' : `${_ctx.topHeight}px` })
        }, [
          _withDirectives((_openBlock(), _createBlock(_component_TableList, {
            ref: rf => { if (rf) _ctx.tableDataRef[0] = rf },
            dataList: _ctx.list,
            columnAllData: _ctx.columnAllData,
            tableName: _ctx.TableName,
            permissionName: _ctx.permissionName,
            showSelection: true,
            showSummary: true,
            isShowPagination: false,
            handleDefaultWidth: 140,
            highlightCurrentRow: true,
            layoutHeight: true,
            newHpx: _ctx.newHpx,
            style: {"height":"calc(100% )","overflow":"hidden"},
            tableRowClassName: _ctx.tableCellClassName,
            onRowClick: _ctx.handleRowClick,
            onCommandChange: _ctx.handleCommand
          }, {
            no: _withCtx((scope) => [
              (scope.row.mark)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    effect: "dark",
                    content: scope.row.mark,
                    placement: "top-start"
                  }, {
                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                      _createElementVNode("i", { class: "iconfont icon-tubiao-40" }, null, -1)
                    ]))]),
                    _: 1
                  }, 8, ["content"]))
                : _createCommentVNode("", true),
              (scope.row.applyCancelStatus === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(scope.row.applyCancelStatus === 1 ? '申请作废' : ''), 1))
                : _createCommentVNode("", true),
              (scope.row.status === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(scope.row.status === 2 ? '申请退回' : ''), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.tableCellClassName(scope))
              }, _toDisplayString(scope.row.no), 3)
            ]),
            "operation-action": _withCtx((scope) => [
              _createVNode(_component_CommandRender, {
                scopeRow: scope.row,
                codeList: _ctx.btnList,
                permissionName: _ctx.permissionName,
                onCommandChange: _ctx.handleCommand
              }, null, 8, ["scopeRow", "codeList", "permissionName", "onCommandChange"])
            ]),
            _: 1
          }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "newHpx", "tableRowClassName", "onRowClick", "onCommandChange"])), [
            [_directive_loading, _ctx.listLoading]
          ]),
          _withDirectives(_createVNode(_component_el_pagination, {
            class: "mt-20",
            total: _ctx.total,
            currentPage: _ctx.listQuery.page,
            "onUpdate:currentPage": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.listQuery.page) = $event)),
            "page-size": _ctx.listQuery.size,
            "page-sizes": _ctx.pageSizes,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            layout: "total, sizes, prev, pager, next"
          }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
            [_vShow, _ctx.total > 0]
          ])
        ], 4),
        (!_ctx.isSubMenuCollapse && _ctx.tabList.length)
          ? (_openBlock(), _createBlock(_component_TableSplitter, {
              key: 0,
              onDragStart: _ctx.handleSplitterDragStart,
              onDragMove: _ctx.handleSplitterDragMove,
              onDragEnd: _ctx.handleSplitterDragEnd
            }, null, 8, ["onDragStart", "onDragMove", "onDragEnd"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: "split-pane-bottom",
          style: _normalizeStyle({ height: `${_ctx.bottomHeight}px` })
        }, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("ul", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: _normalizeClass({ active: _ctx.activeTab === item.id }),
                  onClick: ($event: any) => (_ctx.handleTabClick(item))
                }, _toDisplayString(item.name), 11, _hoisted_20))
              }), 128))
            ])
          ]),
          (_ctx.activeTab === 3)
            ? (_openBlock(), _createBlock(_component_TraceInfo, {
                key: 0,
                ref: "TraceInfo",
                id: _ctx.activeId,
                api: "invoice"
              }, null, 8, ["id"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 2)
            ? (_openBlock(), _createBlock(_component_BusinessInfo, {
                key: 1,
                ref: "TraceInfo",
                id: _ctx.activeId,
                api: "invoice"
              }, null, 8, ["id"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 1)
            ? (_openBlock(), _createBlock(_component_LogisticTable, {
                key: 2,
                sendFlag: 0,
                TableName: "TABLE_DELIVERY_INFO",
                permissionName: "LOGISTIC_INFO",
                ref: "LogisticTable",
                sourceId: _ctx.activeId,
                sourceType: 3
              }, null, 8, ["sourceId"]))
            : _createCommentVNode("", true)
        ], 4), [
          [_vShow, !_ctx.isSubMenuCollapse && _ctx.tabList.length]
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible && !_ctx.approvalCancelVisible && !_ctx.approvalBackVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: 'invoice',
          handleResolveTempData: _ctx.handleResolveTempData,
          "onUpdate:visibel": _cache[15] || (_cache[15] = () => _ctx.dialogFormVisible = false),
          onSubmit: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "dialogFormVisible", "handleResolveTempData"]))
      : _createCommentVNode("", true),
    (_ctx.dengjiVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.dengjiVisible,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.dengjiVisible) = $event)),
          width: "80%",
          title: ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_25, [
              _createVNode(_component_el_button, {
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.dengjiVisible = false)),
                type: "danger"
              }, {
                default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleDJ
              }, {
                default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                  _createTextVNode("确定", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _cache[54] || (_cache[54] = _createElementVNode("div", { class: "form-title mb-10" }, [
              _createElementVNode("span", { class: "label blue" }, "开"),
              _createElementVNode("span", { class: "left" }, "开票信息")
            ], -1)),
            _createVNode(_component_el_descriptions, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "金额：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$currency(_ctx.activeRow.amount)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "公司抬头：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.title), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "税率：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.rate) + "%", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "客户公司名称：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.customerCompanyName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "客户发票抬头：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.titleName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "税号：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.taxId), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "开户行及账号：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.bank) + _toDisplayString(_ctx.activeRow.account), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "地址、电话：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.registeredAddress) + _toDisplayString(_ctx.activeRow.phone), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "备注：" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.activeRow.mark), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _cache[55] || (_cache[55] = _createElementVNode("div", { class: "form-title mt-20 mb-20" }, [
              _createElementVNode("span", { class: "label yellow" }, "开"),
              _createElementVNode("span", { class: "left" }, "开票记录")
            ], -1)),
            _createVNode(_component_el_table, {
              data: _ctx.DJTableData,
              border: "",
              style: {"width":"100%"},
              "max-height": "400px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "发票号码",
                  prop: "no",
                  "min-width": "120"
                }),
                _createVNode(_component_el_table_column, {
                  label: "发票代码",
                  prop: "code",
                  "min-width": "120"
                }),
                _createVNode(_component_el_table_column, {
                  label: "发票校验码",
                  prop: "checkCode",
                  "min-width": "180"
                }),
                _createVNode(_component_el_table_column, {
                  label: "开票日期",
                  prop: "date",
                  "min-width": "120"
                }),
                _createVNode(_component_el_table_column, {
                  label: "发票金额",
                  prop: "amount",
                  align: "right",
                  "min-width": "120"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ color: row.amount < 0 || row.type === '退票' ? '#E6A23C' : '#67C23A', fontWeight: 'bold' })
                    }, _toDisplayString(_ctx.$currency(row.amount)), 5)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "发票类型",
                  prop: "type",
                  width: "110",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_tag, {
                      type: row.type === '退票' || row.amount < 0 ? 'warning' : 'success',
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.type === '退票' || row.amount < 0 ? '退票' : '正常发票'), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "登记日期",
                  prop: "createTime",
                  "min-width": "140"
                }),
                _createVNode(_component_el_table_column, {
                  label: "状态",
                  prop: "status",
                  width: "110",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_tag, {
                      type: row.status === 0 ? 'info' : 'success',
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.status === 0 ? '已退票作废' : '正常'), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(['label', _ctx.djMode === 'refund' ? 'yellow' : 'green'])
                }, _toDisplayString(_ctx.djMode === 'refund' ? '退' : '登'), 3),
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.djMode === 'refund' ? '登记退票 (红字发票冲销)' : '登记发票 (正常开票)'), 1)
              ]),
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.djMode,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.djMode) = $event)),
                size: "small",
                onChange: _ctx.handleDjModeChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_button, { label: "normal" }, {
                    default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                      _createTextVNode("正常开票", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio_button, {
                    label: "refund",
                    disabled: !_ctx.hasPositiveInvoices
                  }, {
                    default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                      _createTextVNode("登记退票", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            (_ctx.djMode === 'refund')
              ? (_openBlock(), _createBlock(_component_el_alert, {
                  key: 0,
                  title: "退票提示：登记退票用于红字冲销已开具的发票。系统将自动冲销作废选中的原发票，并将本次退票金额自动记为负数冲减已开票额。",
                  type: "warning",
                  closable: false,
                  "show-icon": "",
                  class: "mb-15"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form, {
              ref: "dataForm",
              model: _ctx.ruleForm,
              rules: _ctx.rules,
              "label-position": "top",
              "label-width": "100px",
              class: "mb-20"
            }, {
              default: _withCtx(() => [
                (_ctx.djMode === 'refund')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "选择冲销原发票",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.ruleForm.originDetailId,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.ruleForm.originDetailId) = $event)),
                          placeholder: "请选择需要退票冲销的原发票",
                          style: {"width":"100%"},
                          onChange: _ctx.handleOriginInvoiceChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positiveInvoices, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: `发票号码: ${item.no} | 金额: ¥${item.amount} | 开票日期: ${item.date || '-'}`,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.djMode === 'normal')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "扫码抢",
                      prop: "invoiceNumber"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.ruleForm.invoiceNumber,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.ruleForm.invoiceNumber) = $event)),
                          type: "textarea",
                          class: "filter-item",
                          onKeyup: _withKeys(_ctx.handleBarCodeChange, ["enter"]),
                          style: {"width":"700px"}
                        }, null, 8, ["modelValue", "onKeyup"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.djMode === 'refund' ? '退票号码 / 红字发票号' : '发票号码',
                    prop: "no"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.no,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.ruleForm.no) = $event)),
                        type: "input",
                        class: "filter-item",
                        placeholder: " "
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: "发票代码",
                    prop: "code"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.code,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.ruleForm.code) = $event)),
                        type: "input",
                        class: "filter-item",
                        placeholder: " "
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "发票校验码",
                    prop: "checkCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.checkCode,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.ruleForm.checkCode) = $event)),
                        type: "input",
                        class: "filter-item",
                        placeholder: " "
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.djMode === 'refund' ? '退票金额' : '发票金额',
                    prop: "amount"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.amount,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.ruleForm.amount) = $event)),
                        type: "input",
                        class: "filter-item",
                        disabled: _ctx.djMode === 'refund',
                        placeholder: " "
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.djMode === 'refund' ? '退票日期' : '开票日期',
                    prop: "date"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.ruleForm.date,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.ruleForm.date) = $event)),
                        type: "date",
                        placeholder: " ",
                        format: "YYYY-MM-DD",
                        "value-format": "YYYY-MM-DD"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.djInfoVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 2,
          modelValue: _ctx.djInfoVisible,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.djInfoVisible) = $event)),
          title: "查看开票信息",
          width: "80%"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_26, [
              _createVNode(_component_el_button, {
                type: "danger",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.djInfoVisible = false))
              }, {
                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                  _createTextVNode("关闭", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: _ctx.DJTableData,
              border: "",
              style: {"width":"100%"},
              "max-height": "400px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "发票号码",
                  prop: "no",
                  "min-width": "120"
                }),
                _createVNode(_component_el_table_column, {
                  label: "发票代码",
                  prop: "code",
                  "min-width": "120"
                }),
                _createVNode(_component_el_table_column, {
                  label: "发票校验码",
                  prop: "checkCode",
                  "min-width": "180"
                }),
                _createVNode(_component_el_table_column, {
                  label: "开票日期",
                  prop: "date",
                  "min-width": "120"
                }),
                _createVNode(_component_el_table_column, {
                  label: "发票金额",
                  prop: "amount",
                  align: "right",
                  "min-width": "120"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ color: row.amount < 0 || row.type === '退票' ? '#E6A23C' : '#67C23A', fontWeight: 'bold' })
                    }, _toDisplayString(_ctx.$currency(row.amount)), 5)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "发票类型",
                  prop: "type",
                  width: "110",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_tag, {
                      type: row.type === '退票' || row.amount < 0 ? 'warning' : 'success',
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.type === '退票' || row.amount < 0 ? '退票' : '正常发票'), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "登记日期",
                  prop: "createTime",
                  "min-width": "140"
                }),
                _createVNode(_component_el_table_column, {
                  label: "状态",
                  prop: "status",
                  width: "110",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_tag, {
                      type: row.status === 0 ? 'info' : 'success',
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.status === 0 ? '已退票作废' : '正常'), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.approvalCancelVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_FormComponent, {
            id: _ctx.activeId,
            dialogFormVisible: _ctx.approvalCancelVisible,
            api: 'invoice',
            isShowCloseBtn: false,
            isShowSubmitBtn: false,
            formDisabled: true,
            mode: "approval"
          }, null, 8, ["id", "dialogFormVisible"]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_el_button, {
              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.approvalCancelVisible = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.handleApprove('approve')))
            }, {
              default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                _createTextVNode(" 通过 ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "danger",
              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.handleApprove('reject')))
            }, {
              default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                _createTextVNode(" 拒绝 ", -1)
              ]))]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.approvalBackVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createVNode(_component_FormComponent, {
            id: _ctx.activeId,
            dialogFormVisible: _ctx.approvalBackVisible,
            api: 'invoice',
            isShowCloseBtn: false,
            isShowSubmitBtn: false,
            formDisabled: true,
            mode: "approval"
          }, null, 8, ["id", "dialogFormVisible"]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_el_button, {
              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.approvalBackVisible = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.handleApprove('approve', 'back')))
            }, {
              default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                _createTextVNode(" 通过 ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "danger",
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.handleApprove('reject', 'back')))
            }, {
              default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                _createTextVNode(" 拒绝 ", -1)
              ]))]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.dialogFormVisible && !_ctx.approvalCancelVisible && !_ctx.approvalBackVisible)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 5,
          type: "primary",
          circle: "",
          onClick: _ctx.handleSubMenuCollapse,
          class: "subMenuCollapseBtn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isSubMenuCollapse ? '展开' : '收起'), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}